export const iconFontAwesomeLogisticsXmarksLines = (
	<i className="fa-solid fa-xmarks-lines"></i>
);
